import slice from "./supportSessionsSlice";

export default slice.reducer;
